import Component from 'Component';
import Login from "./auth/Login";
import MagicLink from "./auth/MagicLink";
import PasswordReset from "./auth/PasswordReset";

export default class Auth extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Login(this.App, this._namespace),
    new MagicLink(this.App, this._namespace),
    new PasswordReset(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}